<template>
    <div class="mask-loading hvc" @touchmove="preventEvents" v-if="loading">
        <img class="loading-gif" src="https://resource.rcclchina.com.cn/Home/mb_loading.gif" alt="loading">
    </div>
</template>

<script>
    export default {
        name: 'Loading',
        props: {
            loading: {
                type: Boolean,
                default: true
            }
        },
        methods: {
            preventEvents (e) {
                e.preventDefault()
            }
        }
    }
</script>

<style lang="less" scoped>
    .mask-loading{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999999;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.7);
        .loading-gif{
            width: 2.05rem;
            height: 2.05rem;
        }
    }
</style>
